import React, { useState } from 'react';
import { Horse } from '../../contexts/HorseContext';
import { SearchIcon, ChevronDownIcon } from 'lucide-react';
interface HorseSelectorProps {
  horses: Horse[];
  selectedHorse: Horse | null;
  onSelectHorse: (horse: Horse) => void;
}
export const HorseSelector: React.FC<HorseSelectorProps> = ({
  horses,
  selectedHorse,
  onSelectHorse
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const toggleDropdown = () => setIsOpen(!isOpen);
  const filteredHorses = horses.filter(horse => horse.name.toLowerCase().includes(searchTerm.toLowerCase()) || horse.birthYear.includes(searchTerm));
  const handleSelectHorse = (horse: Horse) => {
    onSelectHorse(horse);
    setIsOpen(false);
    setSearchTerm('');
  };
  return <div className="relative" data-id="element-340">
      <div className="border border-gray-300 rounded-md p-3 flex justify-between items-center cursor-pointer" onClick={toggleDropdown} data-id="element-341">
        <div className="flex-1" data-id="element-342">
          {selectedHorse ? <span data-id="element-343">
              {selectedHorse.name} ({selectedHorse.birthYear})
            </span> : <span className="text-gray-500" data-id="element-344">Pferd auswählen</span>}
        </div>
        <ChevronDownIcon size={20} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-345" />
      </div>
      {isOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg" data-id="element-346">
          <div className="p-2 border-b" data-id="element-347">
            <div className="relative" data-id="element-348">
              <input type="text" placeholder="Nach Name oder Geburtsjahr suchen..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full p-2 pl-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" onClick={e => e.stopPropagation()} data-id="element-349" />
              <SearchIcon size={16} className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-350" />
            </div>
          </div>
          <ul className="max-h-60 overflow-y-auto" data-id="element-351">
            {filteredHorses.length === 0 ? <li className="p-3 text-gray-500 text-center" data-id="element-352">
                Keine Pferde gefunden
              </li> : filteredHorses.map(horse => <li key={horse.id} className="p-3 hover:bg-[#96c11f]/10 cursor-pointer" onClick={() => handleSelectHorse(horse)} data-id="element-353">
                  <div className="font-medium" data-id="element-354">{horse.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-355">
                    {horse.breed}, Geburtsjahr: {horse.birthYear}
                  </div>
                </li>)}
          </ul>
        </div>}
    </div>;
};